// src/Components/modules/Coordinacion/PaginationControl.js

import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Pagination, Select, Button, Tooltip } from "antd";
import { VerticalAlignTopOutlined } from "@ant-design/icons";

const { Option } = Select;

const PaginationControl = ({
  currentPage,
  itemsPerPage,
  totalItems,
  totalAbsoluto, // Total absoluto sin filtros (opcional)
  onPageChange,
  onItemsPerPageChange,
  onScrollToTop, // Función para hacer scroll al inicio
}) => (
  <Row
    justify="space-between"
    align="middle"
    style={{
      padding: "12px 16px",
      paddingTop: "16px",
      paddingBottom: "16px",
      backgroundColor: "#ffffff",
      borderTop: "1px solid rgba(0,0,0,0.08)",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.03)",
    }}
  >
    <Col>
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Select
          value={itemsPerPage}
          onChange={(value) => onItemsPerPageChange(value)}
          style={{ width: 120 }}
          size="middle"
        >
          <Option value={10}>10 / página</Option>
          <Option value={20}>20 / página</Option>
          <Option value={50}>50 / página</Option>
          <Option value={100}>100 / página</Option>
        </Select>
        <Tooltip title="Ir arriba">
          <Button
            icon={<VerticalAlignTopOutlined />}
            onClick={onScrollToTop}
            size="middle"
            style={{
              backgroundColor: "#0a2e5c",
              borderColor: "#0a2e5c",
              color: "#ffffff",
            }}
          />
        </Tooltip>
      </div>
    </Col>

    <Col>
      <Pagination
        current={currentPage}
        pageSize={itemsPerPage}
        total={totalItems}
        onChange={onPageChange}
        showSizeChanger={false}
        showTotal={(total) =>
          totalAbsoluto && totalAbsoluto !== total
            ? `Total ${total} traslados de ${totalAbsoluto}`
            : `Total ${total} traslados`
        }
      />
    </Col>
  </Row>
);

PaginationControl.propTypes = {
  currentPage: PropTypes.number.isRequired,
  itemsPerPage: PropTypes.number.isRequired,
  totalItems: PropTypes.number.isRequired,
  totalAbsoluto: PropTypes.number, // Total absoluto sin filtros (opcional)
  onPageChange: PropTypes.func.isRequired,
  onItemsPerPageChange: PropTypes.func.isRequired,
  onScrollToTop: PropTypes.func, // Función para hacer scroll al inicio
};

export default PaginationControl;
